import Axios from "axios"
import { ApiResponse, handleApiErrors } from ".."
import * as Models from "./models"

const baseUrl = () => {
    return `${process.env.REACT_APP_MOBILBASE_API}/api/v1/short`
}

export async function getLocations(): Promise<ApiResponse<Models.Location[]>> {
    return Axios.get<Models.Location[]>(`${baseUrl()}/locations`)
        .then(res => { return {data: res.data, errorStatus: undefined, errorMessage: undefined} })
        .catch((e) => handleApiErrors<Models.Location[]>(e))
}

export async function getAllLocations(): Promise<ApiResponse<Models.Location[]>> {
    return Axios.get<Models.Location[]>(`${baseUrl()}/locations/all`)
        .then(res => { return {data: res.data, errorStatus: undefined, errorMessage: undefined} })
        .catch((e) => handleApiErrors<Models.Location[]>(e))
}

export async function getDevices(locationId: number): Promise<ApiResponse<Models.Device[]>> {
    return Axios.get<Models.Device[]>(`${baseUrl()}/devices/${locationId}`)
        .then(res => { return {data: res.data, errorStatus: undefined, errorMessage: undefined} })
        .catch((e) => handleApiErrors<Models.Device[]>(e))
}

export async function getUsers(): Promise<ApiResponse<Models.User[]>> {
    return Axios.get<Models.User[]>(`${baseUrl()}/users`)
        .then(res => { return {data: res.data, errorStatus: undefined, errorMessage: undefined} })
        .catch((e) => handleApiErrors<Models.User[]>(e))
}
